<script>
import { onMount } from "svelte";


  export let text;
  export let backgroundColor='var(--primary)';
  export let color='var(--background)';

  let height;
  let spacer; 
  let banner;
  
  onMount(() => {
    banner.style.top = spacer.offsetTop +'px';
  })
</script>

<div class='banner-spacer' style="height: {height}px" bind:this={spacer}></div>
<div class='big-banner' style="background-color: {backgroundColor}; " bind:clientHeight={height} bind:this={banner}>
  <h1 style="color: {color}">{text}</h1>
</div>

<style>
  .banner-spacer {
    background-color: transparent;
    pointer-events: none;
    /* height: 20vh; */
  }
  .big-banner {
    margin:0;
    /* background-color: #60f; */
    /* color: #fff; */
    position: fixed;
    left: 0;
    z-index: -1;
    min-height: 20vh;
    /* bottom: 50vh;; */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;  
  }
  .big-banner h1 {
    font-size: 3em;
    padding: 20px;
  }
  @media (max-width: 800px) {
    .big-banner h1 {
      font-size: 2.5em;
      font-weight: 500;
    }
  }

</style>